function preserveUnsetFilters(filters: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(filters).map(([key, value]) => [
      key,
      value === undefined ? null : value,
    ])
  );
}

/**
 * Query key factory for package queries.
 * Provides consistent, hierarchical keys for cache management.
 */
export const packageQueryKeys = {
  all: ['packages'] as const,
  lists: () => [...packageQueryKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) =>
    [...packageQueryKeys.lists(), preserveUnsetFilters(filters)] as const,
  sendFlowList: (dealId: string) =>
    [...packageQueryKeys.lists(), 'send-flow', dealId] as const,
  details: () => [...packageQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...packageQueryKeys.details(), id] as const,
  visitors: (id: string) =>
    [...packageQueryKeys.all, 'analytics', 'visitors', id] as const,
  timePerSection: (id: string) =>
    [...packageQueryKeys.all, 'analytics', 'time-per-section', id] as const,
  dailyEngagement: (id: string) =>
    [...packageQueryKeys.all, 'analytics', 'daily-engagement', id] as const,
  analyticsSummary: (id: string) =>
    [...packageQueryKeys.all, 'analytics', 'summary', id] as const,
} as const;
